// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3WulK","left":"InfoRow_left__2u0m7"};